import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import View from '@bubble-ui/primitive-view';
import SpacerVertical from '@bubble-ui/atom-spacer-vertical';
import { layoutCalculation, fieldIndex, positionInFieldset } from './layoutCalculation';
export var calculateContent = _ref => {
  var {
    fields,
    isBorderless,
    bottomBordersSquare,
    withLayoutSpacing
  } = _ref;
  var rows = layoutCalculation(fields.map(_ref2 => {
    var {
      size
    } = _ref2;
    return size;
  }));
  return rows.map((row, rowIndex) => {
    var isLastRow = rowIndex === rows.length - 1;
    return /*#__PURE__*/React.createElement(View, {
      key: "row-".concat(rowIndex),
      style: {
        width: '100%',
        flexDirection: 'row',
        gap: isBorderless ? 20 : undefined
      }
    }, row.map((width, sizeIndex) => {
      var indexInFields = fieldIndex(rows, rowIndex, sizeIndex);
      var {
        Component,
        size,
        props
      } = fields[indexInFields];
      if (bottomBordersSquare && isLastRow && !isBorderless) {
        props.squareBottomBorder = true;
      }
      var position = positionInFieldset(rows, rowIndex, sizeIndex);
      if (withLayoutSpacing) {
        return /*#__PURE__*/React.createElement(View, {
          key: props.name !== undefined ? props.name : "".concat(rowIndex, "-").concat(sizeIndex),
          style: {
            flex: width || size
          }
        }, /*#__PURE__*/React.createElement(Component, _extends({}, props, {
          position: position,
          stack: rowIndex !== 0
        })), !isLastRow && /*#__PURE__*/React.createElement(SpacerVertical, {
          spaceToken: "space/100"
        }));
      }
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        // unset `width` prop because it will break the layout
        width: undefined,
        UNSAFE_width: width,
        position: position,
        stack: rowIndex !== 0,
        key: props.name !== undefined ? props.name : "".concat(rowIndex, "-").concat(sizeIndex)
      }));
    }));
  });
};
//# sourceMappingURL=calculateContent.js.map